import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Divider } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: '15px !important'
    },
}));

export default function PopOver(props) {
    //   const [open, setOpen] = React.useState(false);
    // const [scroll, setScroll] = React.useState('paper');
    const classes = useStyles();
    const [value, setValue] = React.useState({});
    const [price, setPrice] = React.useState(props.price);

    const handleChange = (index, event) => {
        var val = value
        val[index] = event.target.value
        setValue(val);
    };

    // const handleClose = () => {
    //     // setOpen(false);
    // };

    const handleCheckboxChange = (key, product_variant, event) => {
        var val = value
        var p = parseFloat(price)
        if (!event.target.checked) {
            p -= parseFloat(val[key].price);
            val[key] = null
        } else {
            val[key] = product_variant
            p += parseFloat(product_variant.price)
        }
        setValue(val);
        setPrice(p.toFixed(2))
    }

    const handleAddToCart = () => {
        var variants = Object.values(value);
        variants = variants.filter((v) => {
            return v !== null
        })
        props.handleAddToCart(variants)
    }

    const descriptionElementRef = React.useRef(null);
    // React.useEffect(() => {
    //     if (open) {
    //         const { current: descriptionElement } = descriptionElementRef;
    //         if (descriptionElement !== null) {
    //             descriptionElement.focus();
    //         }
    //     }
    // }, [open]);
    const variant = props.variant
    return (
        <div>
            <Dialog
                classes={{
                    root: classes.root,
                    paper: classes.root
                }}
                open={props.open}
                onClose={props.handleClose}
                fullWidth={true}
                scroll={'paper'}
                maxWidth={'xs'}
                style={{ borderRadius: '15px' }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >

                <DialogContent dividers={true} style={{ padding: '0px' }}>
                    <div style={{
                        display: 'inline-block',
                        position: 'relative', textAlign: 'center', width: '100%', height: '250px'
                    }}>
                        <img src={props.image} width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                        <IconButton size={"small"} style={{
                            position: 'absolute',
                            top: 12,
                            right: 12,
                            background: 'white',
                            opacity:'0.5'
                        }} aria-label="close" onClick={props.handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        style={{ paddingLeft: '5%', paddingTop: '5%', paddingRight: '5%' }}
                    >
                        <Typography
                            component="h5"
                            variant="h5"
                            style={{ fontWeight: 'bold',color:'black', fontSize: '20px' }}
                        >
                            {props.title}
                        </Typography>

                    </DialogContentText>
                    <Divider></Divider>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        style={{ padding: '5%' }}
                    >
                        {variant && variant.map((v, index) => {
                            return (v.product_variant ? <div><FormControl component="fieldset" style={{ width: '100%' }}>
                                <FormLabel component="legend" style={{ fontWeight: 'bold' ,color:'black'}}>{v.heading}</FormLabel>
                                <RadioGroup aria-label={index} name={index} style={{ width: '100%' }} >
                                    {v.product_variant.map((product_variant, i) => {
                                        return (
                                            <div style={{ marginBottom: '5%' }}>
                                                <FormControlLabel value={JSON.stringify(product_variant)} control={<Checkbox onChange={(event) => handleCheckboxChange(index + '_' + i, product_variant, event)} />} style={{color:'black'}} label={product_variant.name} />
                                                <span style={{ color:'black',float: 'right', marginTop: '3%' }}>{product_variant.price + ' AUD'}</span>
                                                <Divider></Divider>
                                            </div>
                                        )
                                    })}
                                </RadioGroup>
                            </FormControl></div> : '')
                        })}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{justifyContent:'center'}}>
                    <div style={{
                        width: '207px',
                        height: '33px',
                        background: 'rgb(1, 160, 90)',
                        border: '1px solid rgb(1, 160, 90)',
                        color: '#fff',
                        borderRadius: '15px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-around',
                        padding: '0 5px',
                        userSelect: 'none',
                        '&:hover': {
                            boxShadow: '1px 1px 2px #000000'
                        }
                    }}>
                        <div onClick={handleAddToCart}>
                            {'Add To Cart - AUD ' + price}
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
}
